import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { ModalTermosUsoComponent } from './modal-termos-uso.component';

@NgModule({
  declarations: [
    ModalTermosUsoComponent
  ],
  imports: [
    CommonModule,
    IonicModule
  ],
  exports: [
    ModalTermosUsoComponent
  ]
})
export class ModalTermosUsoModule { }
